import { useMemo } from "react";
import { MRT_ColumnDef } from "material-react-table";

import { IconTrash } from "@tabler/icons-react";

import VirtualizedTable from "./VirtualizeTable";

import { formatCpfCnpj, formatDate } from "../helpers/format";

const BranchesTableComponent = ({
  data,
}: {
  data: Array<{
    id: string;
    name: string;
    document: string;
    createdAt: string | Date;
    status: string;
  }>;
  refetch?: () => void;
}) => {
  const columns = useMemo<MRT_ColumnDef<(typeof data)[0]>[]>(() => {
    return [
      {
        accessorKey: "status",
        header: "Status",
        size: 80,
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
        Cell: ({ cell }) => {
          const status = cell.getValue() as string;
          let label = "";
          let color = "";

          if (status) {
            label = "Ativo";
            color = "#2e7d32";
          }

          if (!status) {
            label = "Inativo";
            color = "#d32f2f";
          }

          return (
            <div
              style={{
                padding: "4px 12px",
                borderRadius: "12px",
                backgroundColor: color,
                color: "#fff",
                fontWeight: 600,
                fontSize: "0.75rem",
                textAlign: "center",
                display: "inline-block",
                minWidth: "100px",
              }}
            >
              {label}
            </div>
          );
        },
      },
      {
        accessorKey: "name",
        header: "Nome",
      },

      {
        accessorKey: "document",
        header: "Documento",
        size: 90,

        Cell: ({ cell }) => formatCpfCnpj(cell.getValue() as string),
      },
      {
        accessorKey: "createdAt",
        header: "Criado em",
        size: 85,

        Cell: ({ cell }) => formatDate(cell.getValue() as string),
      },

      {
        id: "delete",
        header: "Excluir",
        size: 50,
        Cell: () => (
          <IconTrash
            onClick={() => {
              window.open(
                "https://wa.me/551926260132?text=Preciso%20de%20suporte",
                "_blank"
              );
            }}
            style={{ cursor: "pointer", color: "#d32f2f" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
    ];
  }, [data]);

  return (
    <>
      <VirtualizedTable
        data={data}
        columns={columns}
        fetchNextPage={() => Promise.resolve()}
        isLoading={false}
      />
    </>
  );
};

export default BranchesTableComponent;
